import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-reset-user',
  templateUrl: './reset-user.page.html',
  styleUrls: ['./reset-user.page.scss'],
})
export class ResetUserPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onClose = () => this.modalCtrl.dismiss(true);

}
